import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PRODUCTS } from "../data/products";
import PariksaLogo from "./PariksaLogo";
import { GranthaIcon } from "./GranthaLogo";
import { DrishtiIcon } from "./DrishtiLogo";
import { ProcureXIcon } from "./SamgrahaLogo";
import { LuminexIcon } from "./VidhanaLogo";
import { NirnayaIcon, SutradharIcon, RachanaIcon } from "./ProductMarks";

function ProductIcon({ slug }) {
  const common = { width: 56, height: 56, viewBox: "0 0 56 56", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" };
  const stroke = "currentColor";
  const accent = "#1E4E8C";
  const map = {
    vidhana: <LuminexIcon size={56} />,
    pariksha: <PariksaLogo size={56} variant="icon" />,
    nirnaya: <NirnayaIcon size={56} />,
    sutradhar: <SutradharIcon size={56} />,
    grantha: <GranthaIcon size={56} />,
    rachana: <RachanaIcon size={56} />,
    drishti: <DrishtiIcon size={56} />,
    samgraha: <ProcureXIcon size={56} />,
  };
  return map[slug] || null;
}

function ProductCard({ p, idx }) {
  const [hover, setHover] = useState(false);
  const isComingSoon = ["rachana", "sutradhar", "samgraha"].includes(p.slug);
  return (
    <Link
      to={`/platforms/${p.slug}`}
      className="product-card reveal"
      style={{ "--d": `${idx * 80}ms` }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      data-testid={`product-card-${p.slug}`}
    >
      {isComingSoon && (
        <div className="product-card-ribbon">
          <span className="coming-soon-pill" data-testid={`coming-soon-${p.slug}`}>Coming Soon</span>
        </div>
      )}
      <div className="product-top">
        <div className="product-icon">
          <ProductIcon slug={p.slug} />
        </div>
        <div className="product-idx mono">{String(idx + 1).padStart(2, "0")} / 08</div>
      </div>
      <div className="product-indo">
        {p.indo}
        <span className="product-dev">{p.devnagari}</span>
      </div>
      {p.english && <div className="product-english">{p.english}</div>}
      <div className="product-name">{p.name}</div>
      <div className="product-tag">{p.tagline}</div>
      <div className="product-caps">
        {p.caps.map((c, i) => (
          <div className="product-cap" key={i}>
            <span className="product-cap-dot" />
            <span>{c}</span>
          </div>
        ))}
      </div>
      <div className="product-foot">
        <span className="product-explore">
          Explore <span className="arrow">→</span>
        </span>
      </div>
    </Link>
  );
}

export function Platforms({ heading = true }) {
  return (
    <section className="platforms reveal" id="platforms" data-testid="platforms-section">
      <div className="container">
        {heading && (
          <div className="platforms-head">
            <div className="section-label"><span className="dot" />Platforms</div>
            <h2 className="platforms-h2 display" data-testid="platforms-h2">
              Eight products. <span style={{ color: "var(--text-3)" }}>One cognitive substrate for capital.</span>
            </h2>
            <p className="platforms-sub">
              Each product carries a Sanskrit name chosen for semantic precision — describing not what the software is, but what it makes possible.
            </p>
          </div>
        )}

        <div className="platforms-cat">
          <div className="cat-bar cat-bar--enhanced" data-testid="platforms-cat-a">
            <div className="cat-bar-num">A</div>
            <div className="cat-bar-body">
              <div className="cat-bar-eyebrow mono">◉ Category A · 04 platforms</div>
              <div className="cat-bar-title">AI-Powered Consulting Platforms</div>
              <div className="cat-bar-sub">Cognitive systems that replace 40-engineer teams — discovery, evaluation, decision intelligence, and generative design.</div>
            </div>
            <div className="cat-bar-rule" />
          </div>
          <div className="platforms-grid">
            {PRODUCTS.slice(0, 4).map((p, i) => (
              <ProductCard key={p.slug} p={p} idx={i} />
            ))}
          </div>
        </div>

        <div className="platforms-cat">
          <div className="cat-bar cat-bar--enhanced" data-testid="platforms-cat-b">
            <div className="cat-bar-num">B</div>
            <div className="cat-bar-body">
              <div className="cat-bar-eyebrow mono">◉ Category B · 04 platforms</div>
              <div className="cat-bar-title">Enterprise Digital Platforms</div>
              <div className="cat-bar-sub">The execution backbone — knowledge fabric, orchestration, controls, and procurement — built native for capital projects.</div>
            </div>
            <div className="cat-bar-rule" />
          </div>
          <div className="platforms-grid">
            {PRODUCTS.slice(4).map((p, i) => (
              <ProductCard key={p.slug} p={p} idx={i + 4} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
